"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InventoryListPageActions;
(function (InventoryListPageActions) {
    InventoryListPageActions["LoadingImages"] = "LoadingImages";
    InventoryListPageActions["ImageCarouselLoaded"] = "ImageCarouselLoaded";
    InventoryListPageActions["ImageCarouselClosed"] = "ImageCarouselClosed";
})(InventoryListPageActions || (InventoryListPageActions = {}));
exports.default = InventoryListPageActions;
